import CompanyTypes from '../types/CompanyTypes';

const initialState = {
  isLoading: false,
  companyData: [],
  companyItemData: {},
  activeCompanyData: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const company = (state = initialState, action) => {
  // console.log(action, 'action');
  switch (action.type) {
    case CompanyTypes.GET_COMPANY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CompanyTypes.GET_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        companyData: action.payload
      };
    case CompanyTypes.GET_COMPANY_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        companyData: []
      };

    case CompanyTypes.GET_COMPANY_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CompanyTypes.GET_COMPANY_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        companyItemData: action.payload
      };
    case CompanyTypes.GET_COMPANY_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        itemData: []
      };

    case CompanyTypes.GET_COMPANY_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CompanyTypes.GET_COMPANY_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeCompanyData: action.payload
      };
    case CompanyTypes.GET_COMPANY_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        activeCompanyData: []
      };
    case CompanyTypes.UPDATE_COMPANY_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword
        }
      };

    default:
      return state;
  }
};
export default company;
